import { AppRoutes } from "views/components/constants/routes";

/** Update with Adam's WhatsApp number (international format, no + or spaces). */
export const PHARMACY_AI_WHATSAPP_URL =
  process.env.REACT_APP_PHARMACY_AI_WHATSAPP_URL ||
  "https://wa.me/353857337077";

export const PHARMACY_AI_CONTACT_EMAIL = "info@taskgo.ie";

export const heroFloatingCards = [
  {
    id: "refills",
    variant: "light" as const,
    title: "Rx Refills",
    description: "WhatsApp agents to handle rx ordering",
    position: { top: "10%", right: "11%" },
  },
  {
    id: "roi",
    variant: "dark" as const,
    stat: "1250%",
    description:
      "(For every 1 euro spent on the software, you're saving 12.50 euros)",
    position: { top: "22%", right: "58%" },
  },
  {
    id: "compliance",
    variant: "dark" as const,
    stat: "98%",
    description: "(SOP compliance from staff members)",
    position: { bottom: "18%", right: "8%" },
  },
  {
    id: "prior-auth",
    variant: "light" as const,
    title: "Appointment reminders",
    description: "Reduce no shows by up to 40%",
    position: { bottom: "9%", left: "10%" },
  },
];

export const products = [
  "SOP & Policy Manager",
  "Error & Complaints Logs",
  "Duty & Temperature Logs",
  "Common Conditions Service",
  "Medicines Optimisation",
  "CD Registers",
  "Purchasing",
  "Prescription Ordering Engine",
  "Service Booking Engine",
  "Health CRM",
  "Call Assistant",
  "WhatsApp Agents",
  "HR Manager",
  "Secure Messaging System",
  "School Booking Engine",
];

export const whatWeDoCards = [
  {
    title: "Reduce cost per script and reduce headcount",
    description:
      "Taskgo replaces repetitive work with intelligent automation, freeing your pharmacy to focus on what matters most",
  },
  {
    title: "Reduce pharmacy service time and increase patient satisfaction",
    description:
      "Remove delays across service intake, clinical screening time, communication workflows so that patient access to services are quicker and more effective.",
  },
  {
    title: "Capture new revenue opportunities",
    description:
      "Scale more services and sales with less efforts. Taskgo unlocks health data for effective health campaigns",
  },
];

export const trustCards = [
  {
    heading: "Purpose – built for Pharmacy",
    text: "Designed by pharmacists, for pharmacists with all workflows in mind",
    gradient: "linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)",
    emoji: "💊",
  },
  {
    heading: "Secure and compliant",
    text: "GDPR & PSI compliant. We ensure detailed audit trails and strict data controls.",
    gradient: "linear-gradient(135deg, #ffedd5 0%, #fed7aa 100%)",
    emoji: "🔒",
  },
  {
    heading: "Enterprise ready",
    text: "Easy onboarding with unlimited team training",
    gradient: "linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)",
    emoji: "⚙️",
  },
];

/** From mapsvg:geoViewBox on public/images/ireland-outline.svg */
export const irelandMapGeo = {
  minLon: -10.617532,
  maxLat: 55.384216,
  maxLon: -5.429631,
  minLat: 51.419751,
} as const;

/** Pin positions (% of map) at Irish towns — aligned to irelandMapGeo. */
export const irelandMapPins: { left: number; top: number }[] = [
  { left: 54, top: 21.3 },
  { left: 41.3, top: 87.9 },
  { left: 30.1, top: 53.3 },
  { left: 38.4, top: 68.6 },
  { left: 67.6, top: 78.8 },
  { left: 62.1, top: 32 },
  { left: 71, top: 14.9 },
  { left: 74.8, top: 28.5 },
  { left: 77.1, top: 35 },
  { left: 75.9, top: 43.7 },
  { left: 65, top: 68.9 },
  { left: 31.4, top: 64.1 },
  { left: 71.2, top: 64.4 },
  { left: 37.6, top: 78.5 },
  { left: 66.2, top: 14.7 },
  { left: 51.6, top: 49.4 },
  { left: 55.6, top: 11 },
  { left: 60.3, top: 53.2 },
  { left: 21.5, top: 83.9 },
  { left: 60.1, top: 76.9 },
  { left: 41.3, top: 27.9 },
  { left: 56.2, top: 76.4 },
  { left: 25.4, top: 38.4 },
  { left: 46.8, top: 44.3 },
  { left: 63.2, top: 46.9 },
  { left: 66.1, top: 65.3 },
  { left: 44.8, top: 89.1 },
  { left: 28.2, top: 32 },
  { left: 21.2, top: 40 },
  { left: 54.4, top: 41.8 },
  { left: 46.7, top: 63.6 },
  { left: 54.3, top: 68.2 },
  { left: 64, top: 59.3 },
  { left: 62.8, top: 35.1 },
  { left: 70.3, top: 28.6 },
  { left: 48.3, top: 18.4 },
  { left: 61.1, top: 6.3 },
  { left: 57.7, top: 83.1 },
  { left: 53.4, top: 86.6 },
  { left: 37.9, top: 81.9 },
  { left: 47, top: 37.5 },
  { left: 36.1, top: 91.8 },
  { left: 26, top: 76.7 },
  { left: 22.5, top: 33.4 },
  { left: 19.9, top: 38.4 },
  { left: 21.8, top: 34.1 },
  { left: 33.8, top: 67.6 },
  { left: 30, top: 34 },
  { left: 47.3, top: 33.4 },
  { left: 52.7, top: 32.3 },
  { left: 54.3, top: 61.4 },
  { left: 68.8, top: 51.6 },
  { left: 71.5, top: 56.2 },
  { left: 77.6, top: 50.4 },
  { left: 51.3, top: 47.2 },
  { left: 45.5, top: 44.7 },
  { left: 36, top: 48.8 },
  { left: 57.6, top: 56.5 },
  { left: 68.1, top: 20.6 },
  { left: 63.4, top: 28.3 },
  { left: 38.1, top: 32.7 },
  { left: 71, top: 75.4 },
  { left: 67.1, top: 72.1 },
  { left: 52.1, top: 57.7 },
  { left: 46.2, top: 57.9 },
  { left: 46.2, top: 51.9 },
  { left: 34, top: 47.1 },
  { left: 39.5, top: 55.2 },
  { left: 36.1, top: 52.7 },
  { left: 32.7, top: 53.4 },
  { left: 62.1, top: 22.9 },
  { left: 61.8, top: 20.2 },
];

export const geoToMapPinPercent = (lat: number, lon: number) => {
  const { minLon, maxLat, maxLon, minLat } = irelandMapGeo;
  return {
    left: ((lon - minLon) / (maxLon - minLon)) * 100,
    top: ((maxLat - lat) / (maxLat - minLat)) * 100,
  };
};

export const pharmacyAiLinks = {
  contact: AppRoutes.contact,
  whatsapp: PHARMACY_AI_WHATSAPP_URL,
  demoEmail: `mailto:${PHARMACY_AI_CONTACT_EMAIL}?subject=${encodeURIComponent("Pharmacy AI Demo Request")}`,
  /** Primary demo CTA — opens contact form (mailto often fails without a desktop mail app). */
  demoContact: `${AppRoutes.contact}?service=${encodeURIComponent("Pharmacy AI")}#contact-form`,
};
